import { useGetStationDisplayName } from "@/entities/station";
import { Vestiging } from "@/entities/vestiging";
import { RoleGate, UserRole } from "@/features/auth";
import { Card, CardContent, CardHeader } from "@/shared/components";

type VestigingCardProps = {
    vestiging: Vestiging;
    showContact?: boolean;
    showOpeningstijd?: boolean;
};

export function VestigingCard({ vestiging, showContact = true, showOpeningstijd = true }: Readonly<VestigingCardProps>) {
    const getStationDisplayName = useGetStationDisplayName();

    return (
        <Card className="text-content-emphasis mr-auto grid gap-4 font-bold" data-testid="vestiging-card">
            <CardHeader className="[container-type:normal] grid gap-1">
                <h4 className="text-xl">{Vestiging.getDisplayName(vestiging)}</h4>
                <span>{getStationDisplayName(vestiging.beheerVestiging.stationCode)}</span>
            </CardHeader>
            <CardContent className="grid [grid-template-columns:repeat(2,minmax(124px,1fr))] gap-8">
                {showContact && (
                    <div>
                        <h5>Contact</h5>
                        <a
                            href={`tel:${vestiging.beheerVestiging.telefoonnummer}`}
                            className="text-content-default font-normal hover:underline"
                        >
                            {vestiging.beheerVestiging.telefoonnummer}
                        </a>
                    </div>
                )}
                {showOpeningstijd && (
                    <div>
                        <h5>Openingstijd</h5>
                        <p className="text-content-default font-normal">
                            {vestiging.currentOpeningstijden.openVan} - {vestiging.currentOpeningstijden.openTot}
                        </p>
                    </div>
                )}
                <RoleGate roles={[UserRole.KLANTENSERVICE]}>
                    {vestiging.beheerVestiging.opmerkingVestiging && (
                        <div className="col-span-2">
                            <h5>Opmerking</h5>
                            <p className="text-content-default font-normal">{vestiging.beheerVestiging.opmerkingVestiging}</p>
                        </div>
                    )}
                </RoleGate>
            </CardContent>
        </Card>
    );
}
